const EXERCISES_UI_DOMAIN = 'exercisesUi'

export default EXERCISES_UI_DOMAIN
